exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-clipper {\n  width: 50%;\n}\n\n.avatar-clipper.active {\n  padding: 20px;\n}\n\n.avatar-preview {\n  width: 30%;\n}\n\n.avatar-preview .wrap {\n  border-radius: 100%;\n}\n\n.avatar-preview.active {\n  padding: 20px;\n}\n\n@media only screen and (max-width: 1024px) {\n  .avatar-preview {\n    width: 30%;\n  }\n}\n@media only screen and (max-width: 800px) {\n  .avatar-clipper {\n    width: 70%;\n  }\n\n  .avatar-preview {\n    width: 70%;\n  }\n}", ""]);

// exports
